import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ratingType',
  standalone: true,
})
export class RatingTypePipe implements PipeTransform {
  constructor() {}

  transform(rating: number): string {
    rating = Number(rating);

    if (!rating || isNaN(rating)) {
      return '';
    }

    if (rating >= 4.2) {
      return 'Superb';
    }

    if (rating >= 3.5 && rating < 4.2) {
      return 'Classy';
    }

    if (rating >= 2.5 && rating < 3.5) {
      return 'Good';
    }

    if (rating >= 1.5 && rating < 2.5) {
      return 'Moderate';
    }

    if (rating > 0 && rating < 1.5) {
      return 'Poor';
    }

    return '';
  }
}
